// Estado del pago de CSR de un cheque respecto a su comprobante (BofA / Zelle).
//   'pending_backup'  el pago ya se registró (o el cheque figura cobrado) pero no hay comprobante subido.
//   'pending_payment' los valores reales están confirmados y todavía no hay ningún pago.
//   null              con comprobante, o el cheque aún no llega al cobro.
// No cambia la contabilidad (deposit / pending / paid): solo señala lo que falta.
export const hasPaymentReceipt = check => (check?.paymentHistory || []).some(payment => payment?.backup?.storageKey);

export const paymentBackupStatus = check => {
  if (!check) return null;
  const collected = check.paid === true || Number(check.deposit) > 0;
  if (collected) return hasPaymentReceipt(check) ? null : 'pending_backup';
  return check.realValuesConfirmed ? 'pending_payment' : null;
};

export const PAYMENT_BACKUP_LABELS = {
  pending_backup: { es: 'Pendiente de backup del pago', en: 'Payment backup pending' },
  pending_payment: { es: 'Pendiente de pago', en: 'Payment pending' }
};
